import React from 'react'
import {
  Box as Body,
  Box,
  CalloutVariant as OriginalCalloutVariant,
  Text,
} from '@node-space/ui-components'

type NotificationVariant = OriginalCalloutVariant | 'gray'
interface NotificationCardProps {
  title: string
  iconComponent: React.ReactNode
  children: React.ReactNode
  iconBackground?: NotificationVariant
}

export const NotificationCard = ({
  title,
  iconComponent,
  children,
  iconBackground = 'gray',
}: NotificationCardProps) => {
  const notificationVariants: Record<NotificationVariant, string> = {
    info: 'bg-secondary-50 text-secondary-500',
    error: 'bg-status-error-50 text-status-error-500',
    warning: 'bg-status-warning-50 text-status-warning-500',
    success: 'bg-status-success-50 text-status-success-500',
    gray: 'bg-gray-03 text-gray-08',
  }

  return (
    <Box
      background="standard"
      hasBorder
      borderRadius={8}
      paddingY={24}
      gapX={24}
      paddingX={32}
      className="relative xs:flex"
    >
      <Box flex justify="center" className="xs:justify-start">
        <Box
          flex
          borderRadius="full"
          size={48}
          centerChildren
          className={notificationVariants[iconBackground]}
        >
          {iconComponent}
        </Box>
      </Box>
      <Body flex flexCol paddingT={12} gapY={12} width={'full'}>
        <Text tag="h2" variant="heading-3">
          {title}
        </Text>
        {children}
      </Body>
    </Box>
  )
}
